import React, { useEffect, useRef } from "react";
import Marquee from "react-fast-marquee";

import GivaLogo from "@/assets/logos/Giva.png";
// import SleepycatLogo from "@/assets/logos/Sleepycat.png";
// import UrbanLadderLogo from '@/assets/logos/udbanlandder.png';
// import FlexnestLogo from "@/assets/logos/Flexnest.png";
// import PepperfryLogo from "@/assets/logos/Pepperfry.png";
// import PidiliteLogo from "@/assets/logos/pidilite.png";
// import TheSleepCompanyLogo from '@/assets/logos/Thesleepcompany.png';
// import TitanEyeLogo from "@/assets/logos/Titanplus.png";
import BluestoneLogo from "@/assets/logos/bluestone.png";
// import WakefitLogo from '@/assets/logos/wakefit.png';
import HomeCentreLogo from "@/assets/logos/homecentre.png";
// import WonderchefLogo from "@/assets/logos/wonderchef.png";
import LenskartLogo from "@/assets/logos/Lenskart.png";
import MilagrowRobotsLogo from "@/assets/logos/milangrowrobots.png";
import afDay from "@/assets/logos/afDay.png";
import izi from "@/assets/logos/IZIcart.png";
import nestRoot from "@/assets/logos/nestRoot.png";
import mecturing from "@/assets/logos/MecTuring.png";
import Argos from "@/assets/logos/argos_logo.png";
import AOT from "@/assets/logos/art_of_time.png";
import EUME from "@/assets/logos/eume.png";
const logos = [
  { name: "Giva", url: GivaLogo },
  // { name: "Sleepycat", url: SleepycatLogo },
  // { name: 'Urban Ladder', url: UrbanLadderLogo },
  // { name: 'Flexnest', url: FlexnestLogo },
  // { name: 'Pepperfry', url: PepperfryLogo },
  // { name: 'Pidilite', url: PidiliteLogo },
  // { name: 'The Sleep Company', url: TheSleepCompanyLogo },
  // { name: 'Titan Eye+', url: TitanEyeLogo },
  { name: "Bluestone", url: BluestoneLogo },
  { name: "Home Centre", url: HomeCentreLogo },
  // { name: 'Wonderchef', url: WonderchefLogo },
  { name: "Lenskart", url: LenskartLogo },
  { name: "Milagrow Robots", url: MilagrowRobotsLogo },
  { name: "izi", url: izi },
  { name: "nestRoot", url: nestRoot },
  { name: "afDay", url: afDay },
  { name: "mecturing", url: mecturing },
  { name: "Argos", url: Argos },
  { name: "AOT", url: AOT },
  { name: "EUME", url: EUME },
];

const TrustedBy: React.FC = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const titleRef = useRef<HTMLHeadingElement>(null);
  const carouselRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            titleRef.current?.classList.add(
              "tw-translate-y-0",
              "tw-opacity-100"
            );

            setTimeout(() => {
              carouselRef.current?.classList.add(
                "tw-translate-y-0",
                "tw-opacity-100"
              );
            }, 300);

            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.2,
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section
      ref={sectionRef}
      className="tw-py-8 md:tw-py-12 tw-bg-black tw-px-6 md:tw-px-12 tw-overflow-hidden"
    >
      <div className="tw-max-w-7xl tw-mx-auto">
        <h2
          ref={titleRef}
          className="tw-text-base tw-font-light tw-uppercase tw-text-center tw-text-gray-400 tw-mb-6 tw-tracking-tight -tw-translate-y-8 tw-opacity-0 tw-transition-all tw-duration-700 tw-ease-out"
          style={{ letterSpacing: "0.3em" }}
        >
          TRUSTED BY
        </h2>
      </div>

      {/* Full-width Swiper outside max-w container */}
      <div
        ref={carouselRef}
        className="tw-translate-y-8 tw-opacity-0 tw-transition-all tw-duration-700 tw-ease-out tw-delay-300 -tw-mx-6 md:-tw-mx-12"
      >
        <Marquee
          gradient={false}
          speed={50}
          pauseOnHover
          // REMOVED: tw-gap-10 (it often doesn't apply to the internal track correctly)
          className="tw-flex tw-overflow-hidden"
        >
          {[...logos, ...logos].map((logo, index) => (
            <div
              key={index}
              // ADDED: tw-mx-8 to force spacing between items
              // REMOVED: tw-gap-5 (useless on single child container)
              className="tw-w-[160px] tw-h-20 tw-mx-8 tw-flex tw-items-center tw-justify-center tw-grayscale hover:tw-grayscale-0 tw-transition-all tw-duration-500 tw-flex-shrink-0"
            >
              <img
                src={logo.url}
                alt={logo.name}
                className="tw-max-h-full tw-object-contain"
              />
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
};

export default TrustedBy;